// CARD_STYLES catalog + useCard helper extracted from prototype.

export const CARD_STYLES = {
  'elevated': {
    id: 'elevated', name: 'Elevated', icon: '📦',
    // Currently identical to glass — explicit starting point from which
    // we'll diverge the two styles.
    getStyle: (theme, hovered) => ({
      background: hovered
        ? `linear-gradient(135deg, ${theme.colors.bgCardHover} 0%, ${theme.colors.bgCardSolid} 100%)`
        : `linear-gradient(135deg, ${theme.colors.bgCardSolid} 0%, ${theme.colors.bgCardHover} 100%)`,
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      border: `1px solid ${hovered ? theme.colors.accent : theme.colors.borderLight}`,
      boxShadow: hovered
        ? `0 12px 40px rgba(0,0,0,0.4), 0 0 40px ${theme.colors.accentGlow || 'rgba(255,215,0,0.4)'}, inset 0 1px 0 rgba(255,255,255,0.08)`
        : `0 4px 16px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.05)`,
      borderRadius: theme.effects?.borderRadiusLg || '12px',
      transform: hovered ? 'translateY(-3px) scale(1.005)' : 'none',
    }),
  },
  'bordered': {
    id: 'bordered', name: 'Bordered', icon: '🖼️',
    // 1.5px border with a translucent fill — the card is defined by its
    // outline rather than a heavy panel. Fill transparency is supplied
    // by the consumer (CampaignCard / SoloCharCard) via rgba bgCardSolid.
    getStyle: (theme, hovered) => ({
      background: hovered ? theme.colors.bgCardHover : theme.colors.bgCardSolid,
      border: `1.5px solid ${hovered ? theme.colors.accent : theme.colors.borderPrimary}`,
      boxShadow: hovered ? `0 0 15px ${theme.colors.accentGlow || 'rgba(255,215,0,0.3)'}` : 'none',
      borderRadius: theme.effects?.borderRadius || '8px',
      transform: hovered ? 'translateY(-2px)' : 'none',
    }),
  },
  'flat': {
    id: 'flat', name: 'Flat', icon: '📄',
    getStyle: (theme, hovered) => ({
      background: hovered ? theme.colors.bgCardHover : theme.colors.bgCardSolid,
      border: hovered ? `1px solid ${theme.colors.accent}40` : 'none',
      boxShadow: hovered ? '0 4px 12px rgba(0,0,0,0.3)' : 'none',
      borderRadius: theme.effects?.borderRadiusSm || '4px',
      transform: 'none',
    }),
  },
  'glass': {
    id: 'glass', name: 'Glass', icon: '✨',
    // Glass treatment: backdrop-blur + a translucent fill. At rest the
    // surface gradient (bgCardSolid → bgCardHover) flows the same way
    // elevated's does — light reads as coming from the bottom-right
    // corner where the brighter, more-opaque stop sits. On hover the
    // gradient reverses *and* a darkening overlay drops in to deepen the
    // bottom-right falloff, signaling activation more strongly than a
    // simple direction flip alone would.
    getStyle: (theme, hovered) => ({
      background: hovered
        ? `linear-gradient(135deg, transparent 0%, rgba(0,0,0,0.22) 100%), linear-gradient(135deg, ${theme.colors.bgCardHover} 0%, ${theme.colors.bgCardSolid} 100%)`
        : `linear-gradient(135deg, ${theme.colors.bgCardSolid} 0%, ${theme.colors.bgCardHover} 100%)`,
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      border: `1px solid ${hovered ? theme.colors.accent : theme.colors.borderLight}`,
      boxShadow: hovered 
        ? `0 12px 40px rgba(0,0,0,0.4), 0 0 40px ${theme.colors.accentGlow || 'rgba(255,215,0,0.4)'}, inset 0 1px 0 rgba(255,255,255,0.08)` 
        : `0 4px 16px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.05)`,
      borderRadius: theme.effects?.borderRadiusLg || '12px',
      transform: hovered ? 'translateY(-3px) scale(1.005)' : 'none',
    }),
  },
};

export const useCard = (theme, cardStyleId = 'elevated', hovered = false) => {
  const cardStyle = CARD_STYLES[cardStyleId] || CARD_STYLES['elevated'];
  return cardStyle.getStyle(theme, hovered);
};
